module.exports = __webpack_public_path__ + "img/Rectangle19top.eb5f866f.png";